import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

/**
 * Een logo dat bij een ontbrekende of kapotte URL netjes terugvalt (initialen of icoon)
 * in plaats van een gebroken plaatje.
 *
 * Waarom: logo's komen als Airtable-bijlage-URL's binnen en die verlopen na een paar uur.
 * Een verouderde URL geeft 410 Gone; zonder terugval staat er dan een gebroken plaatje.
 *
 * @param src       URL van het logo (mag leeg zijn)
 * @param fallback  wat er staat als er geen (werkend) logo is
 * @param sx        stijl van het <img>
 */
export default function LogoMetTerugval({ src, fallback = null, sx }) {
  const [kapot, setKapot] = useState(false);
  // Nieuwe URL (bv. na verversen): opnieuw proberen.
  useEffect(() => { setKapot(false); }, [src]);

  if (!src || kapot) return fallback;
  return <Box component="img" src={src} alt="" onError={() => setKapot(true)} sx={sx} />;
}
